import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { SVG, SettingsRadio } from "ui";

const Messages = () => {
    const [selectedOption, setSelectedOption] = useState<
        "no-one" | "followers" | "selected-followers"
    >("followers");

    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page account-info-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Messages Settings</h1>
                    <div></div>
                </div>

                <div className="card pl-10 pr-10 pt-10 pb-10">
                    <SettingsRadio
                        title="No one"
                        svg="message-circle"
                        details="No one from Momeento can send direct messages to me"
                        checked={selectedOption == "no-one"}
                        handleClick={() => setSelectedOption("no-one")}
                    />

                    <SettingsRadio
                        title="Followers Only"
                        svg="message-circle"
                        details="Only my followers can send me direct messages"
                        checked={selectedOption == "followers"}
                        handleClick={() => setSelectedOption("followers")}
                    />

                    <SettingsRadio
                        title="Selected Followers"
                        svg="message-circle"
                        details="Only selected followers can send me direct messages"
                        checked={selectedOption == "selected-followers"}
                        handleClick={() =>
                            setSelectedOption("selected-followers")
                        }
                    />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Messages;
